import { useLanguage } from "../i18n/LanguageContext";
import { BRAND } from "../lib/images";
import { Reveal } from "../components/Reveal";
import { SEO } from "../components/SEO";

const GALLERY = [
  { src: BRAND.heroGroup, alt: "Guests enjoying a golden-hour picnic on a hillside above the Mediterranean" },
  { src: BRAND.terraceNice, alt: "Bohemian picnic spread overlooking Nice and the Baie des Anges" },
  { src: BRAND.floating, alt: "Floating Picnic — guests relaxing on the floating lounge at Villefranche-sur-Mer" },
  { src: BRAND.dj, alt: "Picnic Electronic — DJ set at sunset among the olive trees" },
  { src: BRAND.toast, alt: "Champagne toast over a picnic by the water" },
  { src: BRAND.couple, alt: "Romantic picnic for two under an olive tree" },
  { src: BRAND.oliveWide, alt: "Picnic setup with cushions and dreamcatcher under the olive trees" },
  { src: BRAND.lanternsSunset, alt: "Sunset picnic with lanterns and friends above the sea" },
  { src: BRAND.spreadRoses, alt: "Picnic spread with red roses and The Nice Picnic chalkboard" },
  { src: BRAND.poufsDay, alt: "Daytime picnic with woven poufs facing Saint-Jean-Cap-Ferrat" },
  { src: BRAND.duskGroup, alt: "Friends gathered on cushions at dusk above the water" },
  { src: BRAND.juteSunset, alt: "Sharing drinks on jute rugs as the sun sets over the hills" },
  { src: BRAND.oliveTall, alt: "Golden light over the olive-tree picnic setup by the bay" },
];

export default function Gallery() {
  const { t } = useLanguage();
  return (
    <div data-testid="gallery-page">
      <SEO title="Gallery — The Nice Picnic, French Riviera"
        description="The Nice Picnic in pictures: bohemian picnics, floating picnics, sunsets and Niçoise tables across Nice and the French Riviera." />
      <section className="pt-36 pb-16 text-center px-5">
        <Reveal>
          <p className="overline-label">{t("gallery.overline")}</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ink mt-4">{t("gallery.title")}</h1>
          <div className="w-16 h-px bg-gold mt-6 mx-auto" />
          <p className="mt-4 text-sm tracking-[0.2em] uppercase text-clay">@the.nicepicnic</p>
        </Reveal>
      </section>
      <section className="pb-24 sm:pb-32 max-w-7xl mx-auto px-5 sm:px-8">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
          {GALLERY.map((g, i) => (
            <Reveal key={i} className="break-inside-avoid">
              <div className={`img-frame ${i % 2 === 0 ? "organic-crop" : "organic-crop-alt"}`}>
                <img src={g.src} alt={g.alt} loading="lazy" className="w-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
